<template>
  <div>
    <FilterToolbarWithSearchBy :hasChanges="hasChanges" :appliedFilters="appliedFilters" @search="search" allowSearchBy
      :searchByOptions="searchByOptions" @update="update" @clear="clear">
      <facet-filter class="border-b" v-model="filters.facets.action" :filter="filterOptions.topic" @input="change" />
    </FilterToolbarWithSearchBy>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as filterOptions from '../../filters/history'
import FilterToolbarWithSearchBy from '@/components/Filters/FilterToolbarWithSearchBy'
import FacetFilter from '@/components/Filters/FacetFilter'

export default {
  components: {
    FacetFilter,
    FilterToolbarWithSearchBy
  },
  data () {
    return {
      hasChanges: false,
      filters: null,
      // filters
      filterOptions: filterOptions,
      searchByOptions: [
        {
          value: 'event_id',
          label: 'Event ID'
        }, {
          value: 'order_id',
          label: 'Order ID'
        }, {
          value: 'shipment_id',
          label: 'Shipment ID'
        }, {
          value: 'cancel_id',
          label: 'Cancel ID'
        }, {
          value: 'rma_id',
          label: 'RMA ID'
        }, {
          value: 'variant_id',
          label: 'Variant ID'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['context'])
  },
  methods: {
    change () {
      this.hasChanges = true
    },
    search (searchByParameter, searchQuery) {
      this.filters.search = {
        parameter: searchByParameter,
        query: searchQuery
      }
      this.$emit('filter', this.filters)
    },
    update () {
      this.hasChanges = false
      this.filters.preset = 'custom'
      this.$emit('filter', this.filters)
    },
    clear () {
      this.filters = {
        preset: 'all',
        facets: {},
        search: {},
        timestamps: {}
      }
      this.$emit('filter', this.filters)
    }
  },
  mounted () {

  },
  props: {
    appliedFilters: {
      type: Object,
      required: true
    }
  },
  watch: {
    appliedFilters: {
      deep: true,
      immediate: true,
      handler (filters) {
        this.filters = filters
      }
    }
  }
}
</script>
